import { useEffect, useState } from 'react';
import type { FormatOptionLabelMeta } from 'react-select';
import type { ReactNode } from 'react';
import ReactSelect from 'react-select';
import { useSchemes } from '@personly/libs-providers';
import { useSelect } from '@personly/libs-hooks';
type Option<T> = {
  label: string;
  value: T;
};
interface Props<T> {
  border?: boolean;
  disabled?: boolean;
  formatOptionLabel?: (option: Option<T>, meta: FormatOptionLabelMeta<Option<T>>) => ReactNode;
  id: string;
  inputId?: string;
  instanceId?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  initialOption?: Option<T>;
  label?: string;
  menuPlacement?: 'bottom' | 'top';
  options: Array<Option<T>>;
  optionSelected: (value?: T) => void;
  placeholder?: string;
  role?: string;
  search?: string;
  searchUpdated?: (value: string) => void;
  selectedOption?: Option<T>;
}
function Select<T>({
  border = false,
  disabled = false,
  formatOptionLabel = option => option.label,
  id,
  inputId,
  initialOption,
  instanceId = 'personly-select',
  isClearable = true,
  isSearchable = true,
  label,
  menuPlacement = 'bottom',
  options,
  optionSelected,
  placeholder,
  role = 'input',
  search = '',
  searchUpdated,
  selectedOption = undefined
}: Readonly<Props<T>>) {
  const {
    cssVariables
  } = useSchemes();
  const {
    bodyElement,
    onChange,
    styles
  } = useSelect(cssVariables, role, disabled, optionSelected, border);
  const [invariantInitialOption] = useState(initialOption);
  useEffect(() => {
    if (invariantInitialOption) onChange(invariantInitialOption);
  }, [invariantInitialOption, onChange]);
  return <ReactSelect aria-labelledby={label} formatOptionLabel={formatOptionLabel} id={id} inputId={inputId} inputValue={search || ''} instanceId={instanceId} isClearable={isClearable} isSearchable={isSearchable} menuPlacement={menuPlacement} menuPortalTarget={bodyElement} onInputChange={searchUpdated} onChange={onChange} options={options} placeholder={placeholder} styles={styles} isMulti={false} value={selectedOption} />;
}
export default Select;